import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Loader2 } from "lucide-react";
import { UserRow } from "@/components/app/UserRow";
import { api } from "@/lib/api";

export function RightSidebar() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [suggested, setSuggested] = useState(null);

  useEffect(() => {
    let on = true;
    api.discover("").then((u) => { if (on) setSuggested(u.slice(0, 4)); }).catch(() => { if (on) setSuggested([]); });
    return () => { on = false; };
  }, []);

  const submit = (e) => { e.preventDefault(); if (q.trim()) navigate(`/explore?q=${encodeURIComponent(q.trim())}`); };

  return (
    <aside className="sticky top-0 hidden h-screen w-[340px] shrink-0 overflow-y-auto border-l border-am-border px-5 py-5 xl:block">
      <form onSubmit={submit} className="flex items-center gap-2 rounded-full border border-am-border bg-am-surface2 px-4">
        <Search className="h-4 w-4 text-am-text3" />
        <input value={q} onChange={(e) => setQ(e.target.value)} onClick={() => navigate("/explore")} data-testid="sidebar-search" placeholder="Search AuraMax" className="w-full bg-transparent py-2.5 text-sm text-white placeholder:text-am-text3 outline-none" />
      </form>

      <section className="mt-5 rounded-2xl border border-aura-magenta/20 bg-gradient-to-b from-am-surface to-am-bg p-4">
        <button onClick={() => navigate("/leaderboard")} data-testid="side-leaderboard" className="flex w-full items-center justify-between">
          <h3 className="text-sm font-bold aura-text">Fresh Aura</h3>
          <span className="text-xs font-semibold text-am-text2 hover:text-white">Leaderboard →</span>
        </button>
        <p className="mt-1 text-xs text-am-text2">Accounts gaining momentum right now.</p>
      </section>

      <section className="mt-5 rounded-2xl border border-am-border bg-am-surface/50 p-3">
        <h3 className="mb-2 px-1 text-sm font-bold text-white">Suggested Creators</h3>
        {suggested === null ? (
          <div className="flex justify-center py-4"><Loader2 className="h-4 w-4 animate-spin text-am-text3" /></div>
        ) : suggested.length === 0 ? (
          <p className="px-1 text-xs text-am-text2">No creators to show yet.</p>
        ) : (
          <div className="space-y-1">{suggested.map((u) => <UserRow key={u.user_id} u={u} />)}</div>
        )}
        <button onClick={() => navigate("/explore")} className="mt-2 px-1 text-xs font-semibold text-am-text2 hover:text-white">Discover more</button>
      </section>

      <p className="mt-5 px-1 text-[11px] leading-relaxed text-am-text3">
        AuraMax · a new social network. Live streaming, identity verification & personal tokens are coming soon.
      </p>
    </aside>
  );
}
